/** Loading-state placeholder blocks, shown while async data is in flight. */

import React from "react";

interface SkeletonProps {
  className?: string;
}

export function Skeleton({ className = "h-4 w-full" }: SkeletonProps): React.ReactElement {
  return <div className={`skeleton ${className}`} />;
}

export function SkeletonCard(): React.ReactElement {
  return (
    <div className="widget-card">
      <Skeleton className="h-3 w-24" />
      <Skeleton className="h-7 w-32" />
      <Skeleton className="h-3 w-40" />
    </div>
  );
}

export function SkeletonRows({ rows = 3 }: { rows?: number }): React.ReactElement {
  return (
    <div className="space-y-2">
      {Array.from({ length: rows }).map((_, i) => (
        <Skeleton key={i} className="h-4 w-full" />
      ))}
    </div>
  );
}
